import PaymentManageComp from "../../../components/mypage/payment/PaymentManageComp";

function PaymentManage() {

  return (
    <PaymentManageComp/>
  );
}

export default PaymentManage;